import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { switchMap, map, take } from 'rxjs/operators';

import * as fromSelectors from '../selectors/internet.selectors';
import * as fromActions from '../actions/internet.actions';

@Injectable()
export class InternetEffects {

  constructor(
    private actions$: Actions,
    private store: Store<any>
  ) { }

  @Effect()
  InitialAction$: Observable<Action> = this.actions$.pipe(
    ofType(fromActions.INTERNET_ACTION_TYPES.INTERNET_INIT),
    switchMap(() => this.store.select(fromSelectors.selectInternetState).pipe(
      take(1),
      map((state) => {
        if (state.online == null) {
          window.addEventListener('online', () => this.store.dispatch(new fromActions.Action_Internet_Online()));
          window.addEventListener('offline', () => this.store.dispatch(new fromActions.Action_Internet_Offline()));
        }
        const onLine = !!window.navigator.onLine;
        if (onLine) {
          return new fromActions.Action_Internet_Online();
        }
        return new fromActions.Action_Internet_Offline();
      })
    ))
  );
}
